import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, Alert, Snackbar } from '@mui/material';
import * as API from '../../api';
import { formatCurrency, parseCurrency } from '../../utils/currencyUtils';

const ExchangeRateDialog = ({ open, onClose }) => {
    const [rate, setRate] = useState(0);
    const [updatedAt, setUpdatedAt] = useState('');

    // --- THÊM STATE TOAST ---
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const showToast = (msg, severity = 'success') => setToast({ open: true, message: msg, severity });
    const handleCloseToast = () => setToast({ ...toast, open: false });

    useEffect(() => {
        if (open) {
            loadRate();
        }
    }, [open]);

    const loadRate = async () => {
        try {
            const res = await API.client.get('/exchange-rates/USD/');
            if(res.data) {
                setRate(parseFloat(res.data.rate));
                setUpdatedAt(res.data.updated_at);
            }
        } catch (error) {
            console.error("Chưa có tỷ giá, sẽ tạo mới khi lưu.");
            setRate(25000); 
        }
    };

    const handleSave = async () => {
        try {
            await API.client.patch('/exchange-rates/USD/', { rate: rate });
            showToast("Đã cập nhật tỷ giá thành công!", "success");
            setTimeout(() => onClose(), 500);
        } catch (error) {
            try {
                await API.client.post('/exchange-rates/', { currency_code: 'USD', rate: rate });
                showToast("Đã khởi tạo tỷ giá thành công!", "success");
                setTimeout(() => onClose(), 500);
            } catch (createError) {
                showToast("Lỗi khi lưu tỷ giá", "error");
            }
        }
    };

    return (
        <>
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ bgcolor: '#007373', color: 'white', fontWeight: 'bold' }}>
                CẤU HÌNH TỶ GIÁ (USD)
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        Tỷ giá hiện tại áp dụng cho toàn hệ thống
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, my: 2 }}>
                        <Typography variant="h6" fontWeight="bold">1 USD = </Typography>
                        <TextField 
                            autoFocus
                            value={formatCurrency(rate)}
                            onChange={(e) => setRate(parseCurrency(e.target.value))}
                            inputProps={{ style: { textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold', color: '#d32f2f' } }}
                            sx={{ width: 150, marginBottom: '0px !important' }}
                        />
                        <Typography variant="h6" fontWeight="bold">VND</Typography>
                    </Box>

                    {updatedAt && (
                        <Alert severity="info" sx={{ fontSize: '0.8rem', py: 0 }}>
                            Cập nhật lần cuối: {new Date(updatedAt).toLocaleString('vi-VN')}
                        </Alert>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Đóng</Button>
                <Button onClick={handleSave} variant="contained" sx={{ bgcolor: '#007373' }}>Lưu thay đổi</Button>
            </DialogActions>
        </Dialog>

        <Snackbar 
            open={toast.open} 
            autoHideDuration={2000} 
            onClose={handleCloseToast}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', boxShadow: 3 }} variant="filled">
                {toast.message}
            </Alert>
        </Snackbar>
        </>
    );
};

export default ExchangeRateDialog;